var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("kt-login__" + _vm.type)},[_c('div',{staticClass:"kt-login__head"},[_vm._t("head")],2),_c('div',{staticClass:"kt-login__form"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }